// 운영 콘솔 상태(최고관리자 전용). 운영은 Tailscale 내부·2FA(배포 설정).
import { defineStore } from 'pinia'
import { api } from '../lib/api'

export const useAdminStore = defineStore('admin', {
  state: () => ({
    metrics: null as any,
    users: [] as any[],
    total: 0,
    audit: [] as any[],
  }),
  actions: {
    async loadMetrics() { this.metrics = await api('GET', '/admin/metrics') },
    async loadUsers(q = '', status = '') {
      const d = await api<any>('GET', `/admin/users?q=${encodeURIComponent(q)}&status=${status}`)
      this.users = d.users; this.total = d.total
    },
    async act(id: string, action: string, reason: string) { await api('POST', `/admin/users/${id}/actions`, { action, reason }) },
    async loadAudit() { this.audit = (await api<any>('GET', '/admin/audit')).audit },
    detail(id: string) { return api<any>('GET', `/admin/users/${id}`) },
  },
})
